var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OfferTypeSearchHandler',_vm._b({},'OfferTypeSearchHandler',_vm.legacySearchService.getFacetComponentBindings(_vm.handler),false),[(_vm.hasLeasing)?_c('OfferTypeLeasingSearchHandler',_vm._b({},'OfferTypeLeasingSearchHandler',
        _vm.legacySearchService.getFacetComponentBindings(_vm.leasingOptionsFacet)
      ,false)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }